import { ArrowDownTrayIcon, InformationCircleIcon, ViewColumnsIcon } from "@heroicons/react/24/outline";
import { LoaderSpinner } from "../LoaderSpinner";

export const CogsCanonicalHeaderToolbar = ({
    onOpenColumnsDrawer,
    onExport,
    onOpenGovernanceDialog,
    withCustomColumns = false,
    isExporting = false,
    hideOnMobile = false,
}) => {
    return (
        <div className={`flex w-full flex-col flex-wrap items-initial justify-end gap-2 sm:w-auto sm:flex-row sm:items-center ${hideOnMobile ? "hidden md:flex" : ""}`}>
            <button
                type="button"
                className="rounded-full border border-gray-300 bg-white p-2 shadow-sm transition hover:bg-gray-50"
                onClick={() => onOpenGovernanceDialog?.()}
                title="Open governance"
                aria-label="Open governance"
            >
                <InformationCircleIcon className="h-4 w-4" aria-hidden />
            </button>
            <button
                type="button"
                className="inline-flex h-auto w-full items-center justify-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-0.5 text-sm text-gray-900 shadow-sm transition hover:bg-gray-50 sm:h-9 sm:w-auto"
                onClick={() => onOpenColumnsDrawer?.()}
            >
                <ViewColumnsIcon className="h-4 w-4" />
                Columns
                {withCustomColumns && (
                    <span className="ml-2 inline-flex w-fit shrink-0 items-center justify-center whitespace-nowrap rounded-md border border-gray-200 bg-white px-1.5 py-0 text-[10px] font-medium text-gray-600 shadow-none">
                        Custom
                    </span>
                )}
            </button>
            <button
                type="button"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white p-2 text-sm text-gray-900 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 sm:h-9 sm:w-auto sm:rounded-md sm:px-3 sm:py-0.5"
                onClick={() => onExport?.()}
                disabled={!onExport || isExporting}
                title="Export table"
                aria-label="Export table"
            >
                {isExporting ? (
                    <LoaderSpinner width={16} height={16} border={2} colorSpinner="black" />
                ) : (
                    <ArrowDownTrayIcon className="h-4 w-4" />
                )}
                <span className="hidden sm:inline">Export</span>
            </button>
        </div>
    );
};
